import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { showPlayer } from 'store/player/actions';
import { StreamTypes } from 'store/player/actions.types';
import { selectChannelsById } from 'store/programs/selectors';

import parseVideoItem from 'services/data-manager/parsing/parseVideoItem';

import isFunction from 'utils/function';
import useGetLiveProgram from 'utils/hooks/useGetLiveProgram';

export default function useTuneToLiveProgram() {
    const dispatch = useDispatch();
    const onGetLiveProgram = useGetLiveProgram();

    const channelsById = useSelector(selectChannelsById);

    return useCallback(
        async (
            channelId: string | undefined,
            railId,
            templateId,
            onRailsSelection,
            index,
        ) => {
            if (channelId) {
                const liveChannel = channelsById[channelId];
                const liveProgram = await onGetLiveProgram(
                    liveChannel.editorial.id,
                );
                const videoItem = parseVideoItem({
                    channel: liveChannel!,
                    program: liveProgram,
                });
                const playbackType = StreamTypes.live;

                if (isFunction(onRailsSelection) && liveProgram) {
                    onRailsSelection({
                        id: liveProgram.id,
                        playbackType,
                        index,
                    });
                }

                dispatch(
                    showPlayer({
                        videoItem,
                        playbackType,
                        railId,
                        templateId,
                    }),
                );
            }
        },
        [dispatch, channelsById, onGetLiveProgram],
    );
}
